// src/components/AccountCreation/constants.js

export const PLANS_CONFIG = {
  'US/Canada': {
    'iOS': {
      'Bronze': { monthly: 12, quarterly: 30, annual: 110 },
      'Gold': { monthly: 22, quarterly: 60, annual: 220 },
    },
    'Android': {
      'Bronze': { monthly: 10, quarterly: 25, annual: 90 },
      'Premium': { monthly: 30, quarterly: 75, annual: 270 },
    }
  },
  'International': {
    'iOS': {
      'Bronze': { monthly: 15, quarterly: 40, annual: 150 },
      'Premium': { monthly: 35, quarterly: 90, annual: 350 },
    },
    'Android': {
      'Gold': { monthly: 25, quarterly: 70, annual: 250 },
      'Premium': { monthly: 32, quarterly: 85, annual: 320 },
    }
  }
};

export const PLAN_FEATURES = {
  Bronze: [
    "Tracks and monitors movements",
    "Cancel Button",
    "Timely Text Notifications - 1 Contact",
    "User Customizable Thresholds",
    "Securely Access Data"
  ],
  Gold: [
    "Everything in the Bronze plan PLUS:",
    "Notifications to Unlimited Contacts", ,
    "Help/SOS Button",
    "Snooze (pause) Button",
    "Records the User’s Heart Rate",
    "Audio Recording",
    "GPS Location",
    "Use Without a Phone**",
    "Reminders for Important Tasks",
    "Report How You Feel"
  ],
  Premium: [
    "Everything in the Gold plan PLUS:",
    "Heart Rate Monitoring (User customizable thresholds)",
    "Notifications Sent for Heart Rate Detection",
    "Safe location monitoring and alerts",
    "Live location tracking (on demand)",
    "Additional Health Metrics"
  ],
  BronzeIntl: [
    "Tracks and monitors movements",
    "Cancel Button",
    "Timely Text Notifications - 1 Contact",
    "User Customizable Thresholds",
    "Securely Access Data"
  ],
  GoldIntl: [
    "Everything in the Bronze plan PLUS:",
    "Notifications to Unlimited Contacts", ,
    "Help/SOS Button",
    "Snooze (pause) Button",
    "Records the User’s Heart Rate",
    "Audio Recording",
    "GPS Location",
    "Use Without a Phone**",
    "Reminders for Important Tasks",
    "Report How You Feel"
  ],
  PremiumIntl: [
    "Everything in the Gold plan PLUS:",
    "Heart Rate Monitoring (User customizable thresholds)",
    "Notifications Sent for Heart Rate Detection",
    "Safe location monitoring and alerts",
    "Live location tracking (on demand)",
    "Additional Health Metrics"
  ]
};

export const PLAN_IMAGES = {
  Bronze: 'https://placehold.co/120x80/a97142/white?text=Bronze',
  Gold: 'https://placehold.co/120x80/e6c96a/white?text=Gold',
  Premium: 'https://placehold.co/120x80/757f9a/white?text=Premium',
  BronzeIntl: 'https://placehold.co/120x80/a97142/white?text=Bronze',
  GoldIntl: 'https://placehold.co/120x80/e6c96a/white?text=Gold',
  PremiumIntl: 'https://placehold.co/120x80/757f9a/white?text=Premium',
};

export const MOCK_CORRECT_OTP = "123456";
